
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupNavigation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GroupNode"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isJoinedByViewer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"postsCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imagesCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"viewerMemberRole"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":123}};
    doc.loc.source = {"body":"\nfragment GroupNavigation on GroupNode {\n    id\n    isJoinedByViewer\n    postsCount\n    imagesCount\n    viewerMemberRole\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
